<header
  class="header-wrapper relative flex justify-content-center align-items-center"
>
  <i
    *ngIf="headerConfig.useBackButton"
    class="backBtn absolute icon icon-arrow-left cursor-pointer"
    (click)="goBack()"
  ></i>
  <a routerLink="/home" class="logo-wrapper flex flex-column align-items-center gap-2 no-underline">
    <img class="logo" src="assets/imgs/logo.png" alt="Skiset Logo" />
    <span class="info">{{ "COMMON.by" | translate }} SKISET</span>
  </a>
  <span class="absolute font-semibold current-lang cursor-pointer" (click)="menu.toggle($event)">{{ currentLang | uppercase }}</span>
  <!-- <img
    class="absolute current-lang cursor-pointer"
    src="/assets/imgs/flags/{{ currentLang }}-flag.png"
    alt="Flag"
    (click)="menu.toggle($event)"
  /> -->
  <i
    *ngIf="headerConfig.useLogoutButton"
    (click)="confirmLogout()"
    class="logoutBtn absolute icon icon-logout cursor-pointer"
  ></i>
  <p-menu #menu [model]="languageOptions" styleClass="language-menu" [popup]="true">
    <ng-template let-item pTemplate="item">
      <span class="flex align-items-center py-2 px-3 gap-2 cursor-pointer" (click)="changeLanguage(item.value)">
        <img class="flag w-1rem" src="/assets/imgs/flags/{{ item.value }}-flag.png" alt="Flag" />
        <span class="text-xs font-medium">{{ item.label | translate }}</span>
      </span>
    </ng-template>
  </p-menu>
</header>
<p-confirmDialog #cd>
  <ng-template pTemplate="headless" let-message>
    <div class="confirm-logout flex flex-column align-items-center p-4 surface-overlay border-round">
      <span class="header text-xs font-medium block">
        {{ 'COMMON.disconnect' | translate }}
      </span>
      <p class="message mb-0 text-xs font-normal text-center">{{ 'COMMON.confirm_logout_msg' | translate }}</p>
      <div class="flex align-items-center gap-2 mt-4">
        <button
          pButton
          [label]="'COMMON.cancel' | translate"
          (click)="cd.reject()"
          severity="secondary"
          [rounded]="true"
          class="p-button-outlined w-8rem ">
        </button>
        <button
          pButton
          [label]="'COMMON.logout' | translate"
          (click)="cd.accept()"
          severity="success"
          [rounded]="true"
          class="w-8rem">
        </button>
      </div>
    </div>
  </ng-template>
</p-confirmDialog>
